import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Mui Libraries
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

// Components
import Nonintegrated from './NonintegratedPage'
import Integrated from './IntegratedPage'
import { fetchPlatform, fetchCategory } from './integrationsSlice';
import Notification from '../../../pages/General/Notification'

// Modernized and polished enterprise dashboard surface item definition
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(3), // Renders standard room padding space for uniform block layout balance
    textAlign: 'center',
    color: '#334155',
    border: "1px solid #E2E8F0",
    borderRadius: '16px', // Matches your modern workspace system radius parameters
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box'
}));

const IntegrationPage = ({ }) => {
    const dispatch = useDispatch();
    const integrations = useSelector(state => state.integrations);
    const integrated = useSelector(state => state.integrated);
    
    return (
        <>
            <Box className="scmaincard" sx={{ width: '100%', mt: 1 }}>
                <Box className="integration--stores" sx={{ width: '100%' }}>
                    <Grid container spacing={3}>
                        
                        {/* ==========================================
                            PART 1: DISCOVERABLE STORES CONFIGURATION SECTION
                            ========================================== */}
                        <Grid item xs={12} lg={6}>
                            <Item>
                                <Box 
                                    className="integration--stores--main"
                                    sx={{ 
                                        width: '100%', 
                                        mb: 3,
                                        position: 'relative'
                                    }}
                                >
                                    <Box className="integration--stores--head" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <Box className="integration--stores--title" sx={{ width: '100%', textAlign: 'left' }}>
                                            <Typography 
                                                variant="h5" 
                                                component="h2" 
                                                sx={{ 
                                                    fontWeight: 800, 
                                                    color: '#0F172A',
                                                    letterSpacing: '-0.5px' 
                                                }}
                                            >
                                                Add your stores
                                            </Typography>
                                        </Box>
                                        
                                        {/* Linear progression timeline overlay sync */}
                                        {integrations && integrations.platform.loading === true && (
                                            <Box sx={{ width: '100%', mt: 1, borderRadius: '4px', overflow: 'hidden' }}>
                                                <LinearProgress sx={{ height: '3px', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                
                                {/* Dynamic Content Block Workspace Injection */}
                                <Box sx={{ width: '100%', flexGrow: 1 }}>
                                    <Nonintegrated />
                                </Box>
                            </Item>
                        </Grid>

                        {/* ==========================================
                            PART 2: ACTIVE ATTACHED STORES HUB LISTENER VIEW
                            ========================================== */}
                        <Grid item xs={12} lg={6}>
                            <Item>
                                <Box sx={{ width: '100%', flexGrow: 1 }}>
                                    <Integrated />
                                </Box>
                            </Item>
                        </Grid>
                        
                    </Grid>
                </Box>
            </Box>
        </>
    )
}

export default IntegrationPage;